import { ApiError, post } from "./Api"
import { IConsentRequest, ICreateConsentResponse } from "../model/Consent";
import config from "../config/Config";

const { hostUrl, apiBasePrefixV1, consentPath } = config;

export const postConsentRequest = async (
  subdomain: string, 
  ecreq: string, 
  rid: string
): Promise<ICreateConsentResponse | ApiError> => {
  const consentRequest = { subdomain, ecreq, rid };
  const url = hostUrl + apiBasePrefixV1 + consentPath
  
  try {
    const response = await post<IConsentRequest, ICreateConsentResponse>(url, consentRequest);

    if (response.status !== 200) {
      return new ApiError(response.message || 'Something went wrong', response.status, "API_ERROR");
    }

    return response.body;

  } catch (error) {
    console.error("Error making API request:", error);
    return new ApiError("Network or server error occurred", 500, "NETWORK_ERROR");
  }
};